import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: 'What types of businesses do you work with?',
  answer: 'Medical and dental clinics, aesthetic clinics, fitness studios, gyms, restaurants, retail chains, hospitality, and other physical-location businesses. Whether you have one location or multiple locations, the systems work.'
}, {
  question: 'How is this different from a marketing agency?',
  answer: 'I don\'t sell "campaigns." I integrate geospatial intelligence, funnel engineering, review systems, automation, and execution to create measurable revenue outcomes — not vanity metrics.'
}, {
  question: 'Do you guarantee results?',
  answer: 'I guarantee transparent execution and strategies anchored in intelligence, not hype. Results depend on market conditions and execution fidelity — our process significantly reduces risk and increases predictability.'
}, {
  question: 'What is the investment required?',
  answer: 'Pricing varies based on current performance, needs, and goals. Initial engagements begin with a structured project, followed by optional optimization partnerships.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-gray-50" data-id="element-85">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-88">
            Common Questions
          </h2>
          <p className="text-gray-600" data-id="element-89">
            Everything you need to know before partnering.
          </p>
        </div>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-92">
                <span className="font-semibold text-gray-900 text-lg" data-id="element-93">
                  {faq.question}
                </span>
                <span className={`ml-4 flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === index ? 'bg-[#ff8a33] text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-94">
                  {openIndex === index ? <Minus size={16} data-id="element-95" /> : <Plus size={16} data-id="element-96" />}
                </span>
              </button>
              <AnimatePresence data-id="element-97">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-98">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-99">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}